import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.076 18.157a3.843 3.843 0 1 0-7.686 0 3.843 3.843 0 0 0 7.686 0M10.076 5.843a3.843 3.843 0 1 0-7.686 0 3.843 3.843 0 0 0 7.686 0M21.606 18.157a3.843 3.843 0 1 0-7.686 0 3.843 3.843 0 0 0 7.686 0M21.606 5.843a3.843 3.843 0 1 0-7.686 0 3.843 3.843 0 0 0 7.686 0"
    }, null, -1)
  ])))
}
export default { render: render }